import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CustomAmountSettings, Design } from '../design-and-amount-settings';
import { GiftCardPurchaseFormService } from '../gift-card-purchase-form/gift-card-purchase-form.service';

@Component({
    selector: 'ols-design-and-amount',
    templateUrl: './design-and-amount.component.html',
    styleUrls: ['./design-and-amount.component.scss'],
    viewProviders: [
        { provide: ControlContainer, useExisting: FormGroupDirective },
    ],
})
export class DesignAndAmountComponent implements OnInit, OnDestroy {
    @Input() designs: Design[];
    @Input() suggestedAmounts: number[];
    @Input() customAmountSettings: CustomAmountSettings;

    isSelectedDesignImageReady = false;

    private ngUnsubscribe = new Subject();

    get selectedItemImagePath() {
        return this.formService.itemImagePath;
    }

    constructor(private formService: GiftCardPurchaseFormService) {}

    ngOnInit(): void {
        this.selectedItemImagePath.valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((_) => {
                this.isSelectedDesignImageReady = false;
            });
    }

    selectedDesignImageReady() {
        this.isSelectedDesignImageReady = true;
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
